export default {
  groupsOfCustomer: state => state.groupsOfCustomer,
  groupOfCustomerInfos: state => state.groupOfCustomerInfos,
  groupsOfCustomerResume: state => state.groupsOfCustomerResume
}
